import moment from "moment";
import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";
import { FormSection } from "components/MainSectionTemplate/types";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import { getInstruction, ContactFormState, ContactFieldMetaData } from "shared/utils/fieldsHelper/contactFields";
import React from "react";
import { formatShortDate } from "utilities";

export const passportSection = (
  formState: ContactFormState,
  fieldMetaData: ContactFieldMetaData
): FormSection => {
  return {
    type: "collapsable",
    key: "passportDetails",
    title: RESX.Passport.resxPassport,
    fields: [{
      ...fieldMetaData.nationality.fields(),
      key: "nationality",
      label: RESX.Passport.Nationality,
      render: () => formState.nationality,
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.contact.maxNationalityLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.nationality,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, { nationality: value });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.passportName.fields(),
      key: "passportName",
      label: RESX.Passport.NameOnPassport,
      render: () => formState.passportName,
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.passport.maxPassportNameLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.passportName,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, { passportName: value });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.passportNumber.fields(),
      key: "passportNumber",
      label: RESX.Passport.PassportNumber,
      render: () => formState.passportNumber,
      inPageEdit: {
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
            maxLength={serverReference.constants.passport.maxPassportNumberLength}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.passportNumber,
        submitChange: (value: string) => {
          const instruction = getInstruction(formState, { passportNumber: value });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.passportIssued.fields(),
      key: "passportIssued",
      label: RESX.Passport.PassportIssuedOn,
      render: () => formatShortDate(formState.passportIssued),
      inPageEdit: {
        render: ({ value, onChange }) => (
          <OptionalDatePicker
            focusOnMount
            value={value}
            onChange={v => onChange(v)}
            validatorKey="contactPassportIssued"
            minDate={moment.utc("1900-01-01")}
            maxDate={moment.utc()}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.passportIssued,
        submitChange: (value: moment.Moment | null) => {
          const instruction = getInstruction(formState, {
            passportIssued: value?.toDate(),
          });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }, {
      ...fieldMetaData.passportExpiration.fields(),
      key: "passportExpiration",
      label: RESX.Passport.PassportExpiresOn,
      render: () => formatShortDate(formState.passportExpiration),
      inPageEdit: {
        render: ({ value, onChange }) => (
          <OptionalDatePicker
            focusOnMount
            value={value}
            onChange={v => onChange(v)}
            validatorKey="contactPassportExpiration"
            minDate={moment.utc("1900-01-01")}
            maxDate={moment.utc().add(30, "years")}
          />
        ),
        type: "confirmOrCancelButton",
        initialValue: formState.passportExpiration,
        submitChange: (value: moment.Moment | null) => {
          const instruction = getInstruction(formState, {
            passportExpiration: value?.toDate(),
          });
          return window.CoreApi.Contact.Update(instruction);
        }
      }
    }]
  }
}